import React, {useState, useReducer, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import queryString from 'query-string';
import isEmpty from 'lodash';
import _ from 'lodash';

import {labels, currentResource} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import env from '../../../util/env';
import {stringFormat} from '@ey/utils';
import {
	projectStatusEnum,
	serviceURL,
	oversightTabs,
	createProjectStepsIndex,
	routeToRedirectEditProject
} from '../../../util/uiconstants';

import {ProjectContext} from './Helper/context';
import {initialState} from './Helper/initialstate';
import reducer from './Helper/reducer';

import {setEditMode, getProjectToEdit} from '../../../actions/EditProject/editprojectactions';
import {
	setRollForwardMode,
	setOversightActiveTab,
	clearAllProjects,
	getProjectDetails
} from '../../../actions/Project/projectAction';
import {
	updateProject,
	draftProject,
	clearProject,
	finishProject
} from '../../../actions/Project/projectcreationactions';
import {clearErrors, raiseJSValidationError} from '../../../actions/erroractions';
import {getAllAccessgroups} from '../../../actions/AccessGroups/Accessgroupactions';
import {getAllClients} from '../../../actions/Clients/clientsaction';

import CreateProjectStep1 from './CreateProjectStep1';
import CreateProjectStep2 from './CreateProjectStep2';
import CreateProjectStep3 from './CreateProjectStep3';
import CreateProjectStep4 from './CreateProjectStep4';

import TemplateFullPage from '../../Templates/TemplateFullPage';
import Modal from '../../CoreWrappers/Modal';
import Loader from '../../Common/LoadingIndicator';
import WizardWrapper from '../../Common/CoreWizard/WizardWrapper';
import StyledWizard from './StyledWizard';
import StyledLoader from './StyledLoader';
import ProgressIndicator from '../../Common/ProgressIndicator';

import {adobeAnalytics} from '@ey/voltron-analytics';
import {clickActionArgs, pageViewArgs} from '../../AdobeAnalytics/actionHelpers.js';
import {
	eventTypes,
	controlTypes,
	locationInPages,
	clickActionNames,
	buttonNames,
	pageNames,
	siteSections
} from '../../AdobeAnalytics/constants.js';

const CreateProjectClassic = (props) => {
	const [saveAsDraft, setSaveAsDraft] = useState(0);
	//for showing loading indicator
	const [isSaving, setIsSaving] = useState(false);
	const [isSavingDraft, setIsSavingDraft] = useState(false);
	const project = useSelector((store) => store.newProject);

	// Below state will maintain current active step
	const [continueToNextStep, setContinueToNextStep] = useState(false);
	const [activeStepIndex, setActiveStepIndex] = useState(createProjectStepsIndex.selectClient);
	const [showWarningForBack, setShowWarningForBack] = useState(false);
	const [isNavigatedFromPreviousStep, setIsNavigatedFromPreviousStep] = useState(false);
	const [navigateToSpecificStep, setNavigateToSpecificStep] = useState(null);
	const [wizardSteps, setWizardSteps] = useState([
		{
			stepName: labels.step1,
			stepDescription: labels.selectClient,
			active: true
		},
		{
			stepName: labels.step2,
			stepDescription: labels.createOrgChart,
			active: false
		},
		{
			stepName: labels.step3,
			stepDescription: labels.connnectToCanvas,
			active: false
		},
		{
			stepName: labels.step4,
			stepDescription: labels.viewSummary,
			active: false
		}
	]);

	//parent state. This state will be used to store each step data
	const [state, dispatch] = useReducer(reducer, initialState);
	const [nodes, setNodes] = useState([]);
	const [clientsLoading, setClientsLoading] = useState(false);

	const isEditMode = useSelector((state) => state.isEditMode.activated);
	const isEditModeData = useSelector((state) => state.isEditMode);
	const isRollForwardMode = useSelector((state) => state.isRollForwardMode);
	const accessGroupsSaved = useSelector((state) => state.accessGroups);
	//	const Activetab = useSelector((state) => state.setOversightActiveTab);
	const oversightActiveTab = useSelector((state) => state.oversightActiveTab);
	const globalDispatch = useDispatch();

	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

	const history = useHistory();
	useEffect(() => {
		if (project.orgStructure.length > 0) {
			setNodes(
				nodes.map((node) => {
					return {
						...node,
						entityId: project.orgStructure?.find((x) => x.id === node.id)?.entityId,
						contacts: project.orgStructure?.find((x) => x.id === node.id)?.contacts
					};
				})
			);
		}
	}, [project]);
	const getProjectId = () => {
		const query = queryString.parse(location.search.toLowerCase());

		return isEmpty(query?.projectid) ? query.projectid : '';
	};

	const getStepId = () => {
		const query = queryString.parse(location.search.toLowerCase());

		return isEmpty(query?.step) ? parseInt(query.step) : 1;
	};

	const projectId = getProjectId();
	const step = getStepId();
	/* Buttons:
	For Create:
	Step 1 -> Cancel, Continue
	Step 2 -> Back, Save as draft, Continue, Cancel
	Step 3 -> Back, Save as draft, Continue, Cancel
	Step 4 -> Back, Save as draft, Continue, Cancel
	Step 5 -> Back, Save as draft, Finish, Cancel
	For edit (Active project):
	Step 1 -> Cancel, Continue
	Step 2 -> Back, Continue, Cancel
	Step 3 -> Back, Continue, Cancel
	Step 4 -> Back, Continue, Cancel
	Step 5 -> Back, SaveChanges, Cancel
	For edit (Draft project):
	Step 1 -> Cancel, Save as draft, Continue
	Step 2 -> Back, Save as draft, Continue, Cancel
	Step 3 -> Back, Save as draft, Continue, Cancel
	Step 4 -> Back, Save as draft, Continue, Cancel
	Step 5 -> Back, SaveChanges, Cancel
	For RF:
	Step 1 -> Cancel, Continue
	Step 2 -> Back, Continue, Cancel
	Step 3 -> Back, Continue, Cancel
	Step 4 -> Back, Continue, Cancel
	Step 5 -> Back, Save as draft, Finish, Cancel*/

	const buttons = [
		{
			label: activeStepIndex === createProjectStepsIndex.selectClient ? labels.cancelLabel : labels.back,
			onClick: () => handlerNavigateBack(),
			isVisible: true,
			variant: 'ghost'
		},
		{
			label: labels.saveDraft,
			onClick: () => handlerOnSaveAsDraftClick(),
			isVisible:
				(activeStepIndex !== createProjectStepsIndex.selectClient && !isEditMode && !isRollForwardMode) ||
				(isEditMode &&
					activeStepIndex !== createProjectStepsIndex.viewSummary &&
					project &&
					project.status === projectStatusEnum.DRAFT) ||
				(isRollForwardMode && activeStepIndex === createProjectStepsIndex.viewSummary)
		},
		{
			label: labels.continue,
			onClick: () => nextClick(),
			isPrimary: true,
			isVisible: activeStepIndex !== wizardSteps.length - 1
		},
		{
			label: !isEditMode ? labels.finish : labels.saveChanges,
			onClick: () => handlerOnFinishClick(),
			isPrimary: true,
			isVisible: activeStepIndex === wizardSteps.length - 1
		},
		{
			isLink: true,
			label: labels.cancelLabel,
			onClick: () => cancelLinkClickCallback(),
			isVisible: activeStepIndex !== createProjectStepsIndex.selectClient,
			variant: 'ghost'
		}
	];

	useEffect(() => {
		setClientsLoading(true);
		const projectIdState = isEditMode ? project.id : project.Id;
		if (projectId && projectIdState !== projectId) {
			setActiveStepIndex(step ? parseInt(step - 1) : 0);
			globalDispatch(getProjectToEdit(projectId, true)).then(() => {
				if (!isEditMode) {
					globalDispatch(setEditMode(true, routeToRedirectEditProject.home, null, null));
				} else {
					globalDispatch(setEditMode(true, isEditModeData.redirect, isEditModeData.nodes, setNodes));
				}
				const url = `${env.getBaseURL(serviceURL)}Clients`;
				globalDispatch(getAllClients()).then(() => {
					setClientsLoading(false);
				});
				globalDispatch(getAllAccessgroups(projectId));
			});
		} else {
			const url = `${env.getBaseURL(serviceURL)}Clients`;
			globalDispatch(getAllClients()).then(() => {
				setClientsLoading(false);
			});
			if (isEditMode) {
				globalDispatch(getAllAccessgroups(projectId));
			}
		}

		// Adobe Analytics Page Tracking
		trackEvent(
			eventTypes.pageView,
			pageViewArgs(projectId ? pageNames.editProject : pageNames.createProject, siteSections.projects)
		);
	}, []);

	useEffect(() => {
		if (isEditMode) {
			//const editProject = _.cloneDeep(project)
			let newOrg;
			if (isEditModeData.nodes === null) {
				newOrg = _.cloneDeep(project.orgStructure);
				newOrg.map((o) => {
					(o.pid = o.parentId), (o.engagementLabel = labels.connectedToEngagements(o.engagements.length));
					o.tags = setTagsForNodes(o.level);
				});
				//setTagsForNodes();
				newOrg = _.map(
					newOrg,
					({pid, engagementLabel, id, engagements, contacts, accessGroups, entityName, admins, domains, tags}) => {
						admins = _.sortBy(admins, 'firstName');
						let firstAdmin =
							admins.length > 0
								? `${admins[0].firstName} ${admins[0].lastName ? admins[0].lastName : ''}`
								: labels.adminsNoneLabel;
						let adminsHeaderLabel = labels.adminsHeaderLabel;
						let adminsMoreCountLabel = '';
						let domainsMoreCountLabel = '';
						if (admins.length > 1) {
							adminsMoreCountLabel = stringFormat(labels.moreCountLabel, admins.length - 1);
						}
						let firstDomain = domains?.length > 0 ? domains[0] : labels.none;
						let domainsHeaderLabel = labels.domainsHeaderLabel;
						if (domains?.length > 1) {
							domainsMoreCountLabel = stringFormat(labels.moreCountLabel, domains.length - 1);
						}
						return {
							pid,
							engagementLabel,
							id,
							engagements,
							contacts,
							accessGroups,
							entityName,
							admins,
							domains,
							tags,
							adminsHeaderLabel,
							firstAdmin,
							domainsHeaderLabel,
							firstDomain,
							adminsMoreCountLabel,
							domainsMoreCountLabel
						};
					}
				);
			}
			setNodes(isEditModeData.nodes === null ? newOrg : isEditModeData.nodes);
		}
	}, [isEditMode]);

	useEffect(() => {
		if (isRollForwardMode) {
			let newOrg = _.map(
				project.orgStructure,
				({pid, engagementLabel, id, engagements, contacts, accessGroups, entityName, admins, domains, tags, level}) => {
					admins = _.sortBy(admins, 'firstName');
					let firstAdmin =
						admins.length > 0
							? `${admins[0].firstName} ${admins[0].lastName ? admins[0].lastName : ''}`
							: labels.adminsNoneLabel;
					let adminsHeaderLabel = labels.adminsHeaderLabel;
					let adminsMoreCountLabel = '';
					let domainsMoreCountLabel = '';
					if (admins.length > 1) {
						adminsMoreCountLabel = stringFormat(labels.moreCountLabel, admins.length - 1);
					}
					let firstDomain = domains?.length > 0 ? domains[0] : labels.none;
					let domainsHeaderLabel = labels.domainsHeaderLabel;
					if (domains?.length > 1) {
						domainsMoreCountLabel = stringFormat(labels.moreCountLabel, domains.length - 1);
					}
					return {
						pid,
						engagementLabel,
						id,
						engagements,
						contacts,
						accessGroups,
						entityName,
						admins,
						domains,
						adminsHeaderLabel,
						firstAdmin,
						domainsHeaderLabel,
						firstDomain,
						adminsMoreCountLabel,
						domainsMoreCountLabel,
						tags: setTagsForNodes(level)
					};
				}
			);
			setNodes(newOrg);
		}
	}, [isRollForwardMode]);

	useEffect(() => {
		return () => {
			var tooltipStep3 = document.getElementById('tooltip-step3');
			tooltipStep3 && tooltipStep3.classList.remove('visible');
			var tooltipStep4 = document.getElementById('tooltip-step4');
			tooltipStep4 && tooltipStep4.classList.remove('visible');
			if (document.querySelector('.componentBodyWrapper.customScrollbar')) {
				document.querySelector('.componentBodyWrapper.customScrollbar').scrollTop = 0;
			}
		};
	}, [activeStepIndex]);

	const setTagsForNodes = (level) => {
		// if (level == 1) {
		// 	return ['rootElement_maxNodeAddedAtNextLevel'];
		// }

		if (level === 2 || level === 3) {
			return ['middleNodeElements'];
		}

		if (level === 4) {
			return ['lastNodeElements'];
		}
	};

	const nextClick = () => {
		switch (activeStepIndex) {
			case createProjectStepsIndex.selectClient:
				// What steps we are doing on continue to step2
				// 1. Update parent state with changed data like name, clients.
				// 2. If projectId is present its update call else create call.
				// 3. Update redux state with changed data name and clients from parent state
				// TODO: If clients are changed, update redux and local state data which is dependant on clients e.g. Available engagements
				setContinueToNextStep(true);
				if (projectId) {
					history.push(`/projects/project?projectId=${projectId}&step=${activeStepIndex + 2}`, null);
				}
				nodes.length === 0 &&
					setNodes([
						{
							id: '1',
							pid: null,
							entityName: labels.enterEntityName,
							engagements: [],
							engagementLabel: labels.connectedToEngagements(0),
							accessGroups: [],
							admins: [],
							domains: [],
							adminsHeaderLabel: labels.adminsHeaderLabel,
							firstAdmin: labels.adminsNoneLabel,
							domainsHeaderLabel: labels.domainsHeaderLabel,
							firstDomain: labels.none,
							adminsMoreCountLabel: '',
							domainsMoreCountLabel: ''
						}
					]);
				break;
			case createProjectStepsIndex.createOrgChart:
				// As step2 data is in parent state, we dont need callback.
				// 1. Validate data
				// 2. Update project api call
				// 3. Update redux state with parentstate data
				if (!isEditMode && !isRollForwardMode) {
					if (ValidateStep2Data()) {
						let projectApiUrl = `${env.getBaseURL(serviceURL)}Projects/${project.Id}`;
						let savedProject = {
							stepUpdated: activeStepIndex + 1,
							...project,
							projectId: project.Id,
							clients: project.clients,
							owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
							users: [],
							orgStructure: nodes.map((node) => {
								return {
									id: node.id.toString(),
									entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId,
									parentId: node.pid?.toString(),
									entityName: node.entityName,
									entityAdmins: node.admins,
									domains: node.domains,
									contacts: node.contacts,
									accessGroups: [],
									engagements: [...node.engagements]
								};
							}),
							entitiesToBeEdited: nodes
								.filter((e) => e.isEdited)
								.map((o) => {
									return o.id.toString();
								})
						};
						savedProject.users = [];
						let payload = {
							savedProject,
							stepUpdated: activeStepIndex + 1
						};

						setIsSaving(true);
						globalDispatch(updateProject(projectApiUrl, payload, isRollForwardMode))
							.then(() => {
								setIsSaving(false);
								setActiveStepIndex(createProjectStepsIndex.connectToEYCanvas);
								if (projectId) {
									history.push(`/projects/project?projectId=${projectId}&step=${activeStepIndex + 2}`, null);
								}
								globalDispatch(clearErrors());
							})
							.catch((e) => {
								setIsSaving(false);
							});
					} else {
						globalDispatch(raiseJSValidationError(currentResource.clientValidationErrors.ErrorStep2DataNotComplete));
						console.error(currentResource.clientValidationErrors.ErrorStep2DataNotComplete);
					}
				} else {
					if (ValidateStep2Data()) {
						globalDispatch(clearErrors());
						setActiveStepIndex(createProjectStepsIndex.connectToEYCanvas);
						if (projectId) {
							history.push(`/projects/project?projectId=${projectId}&step=${activeStepIndex + 2}`, null);
						}
					} else {
						globalDispatch(raiseJSValidationError(currentResource.clientValidationErrors.ErrorStep2DataNotComplete));
						console.error(currentResource.clientValidationErrors.ErrorStep2DataNotComplete);
					}
				}

				break;
			case createProjectStepsIndex.connectToEYCanvas:
				// Step3 modifies existing org structure from step2, here we just need to update
				// engagements to entities
				// 1. Validate data
				// 2. Update project api call
				// 3. Update redux state with parentstate data
				// Call Update API for edit also. Will not save any data in db but will get the users details in response
				if (!isRollForwardMode) {
					const projectId = isEditMode ? project.id : project.Id;
					let projectApiUrl = `${env.getBaseURL(serviceURL)}Projects/${projectId}`;
					if (ValidateStep3Data()) {
						let savedProject = {
							stepUpdated: activeStepIndex + 1,
							isSave: isEditMode ? false : true,
							...project,
							clients: [...project.clients],
							owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
							users: [],
							orgStructure: nodes.map((node) => {
								return {
									id: node.id.toString(),
									parentId: node.pid?.toString(),
									entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId,
									entityName: node.entityName,
									entityAdmins: node.admins,
									domains: node.domains,
									contacts: node.contacts,
									accessGroups: [],
									engagements: [...node.engagements]
								};
							}),
							entitiesToBeEdited: nodes
								.filter((e) => e.isEdited)
								.map((o) => {
									return o.id.toString();
								})
						};

						let payload = {
							savedProject,
							stepUpdated: activeStepIndex + 1
						};

						setIsSaving(true);
						globalDispatch(updateProject(projectApiUrl, payload, isRollForwardMode))
							.then(() => {
								setIsSaving(false);
								setActiveStepIndex(createProjectStepsIndex.viewSummary);
								if (projectId && isEditMode) {
									history.push(`/projects/project?projectId=${projectId}&step=${activeStepIndex + 2}`, null);
								}
								globalDispatch(clearErrors());
							})
							.catch((e) => {
								const errorCode = e?.response?.data?.errors?.Error[0]?.split('-')[0].trim() || '';
								if (currentResource.Errors[errorCode]) {
									dispatch(raiseJSValidationError(errorCode + ' - ' + currentResource.Errors[errorCode]));
								}
								setIsSaving(false);
							});
					} else {
						globalDispatch(
							raiseJSValidationError(
								currentResource.clientValidationErrors.ErrorAtleastOneEngagementAssociationRequired
							)
						);
						console.error(currentResource.clientValidationErrors.ErrorAtleastOneEngagementAssociationRequired);
					}
				} else {
					const projectId = project.Id || project.projectId;
					let projectApiUrl = `${env.getBaseURL(serviceURL)}Projects/${projectId}`;
					if (ValidateStep3Data()) {
						let savedProject = {
							name: state.name,
							isSave: false,
							stepUpdated: activeStepIndex + 1,
							status: projectStatusEnum.ACTIVE,
							clients: [...state.clients],
							owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
							users: [...project.users],
							orgStructure: nodes.map((node) => {
								return {
									id: node.id.toString(),
									parentId: node.pid?.toString(),
									entityName: node.entityName,
									accessGroups: [],
									engagements: [...node.engagements],
									entityAdmins: node.admins,
									domains: node.domains,
									contacts: node.contacts
								};
							}),
							entitiesToBeEdited: nodes
								.filter((e) => e.isEdited)
								.map((o) => {
									return o.id.toString();
								})
						};

						let payload = {
							savedProject,
							stepUpdated: activeStepIndex + 1
						};
						setIsSaving(true);
						globalDispatch(updateProject(projectApiUrl, payload, isRollForwardMode))
							.then(() => {
								setIsSaving(false);
								setActiveStepIndex(createProjectStepsIndex.viewSummary);
								if (projectId) {
									history.push(`/projects/project?projectId=${projectId}&step=${activeStepIndex + 2}`, null);
								}
								globalDispatch(clearErrors());
							})
							.catch((e) => {
								setIsSaving(false);
							});
					} else {
						globalDispatch(
							raiseJSValidationError(
								currentResource.clientValidationErrors.ErrorAtleastOneEngagementAssociationRequired
							)
						);
						console.error(currentResource.clientValidationErrors.ErrorAtleastOneEngagementAssociationRequired);
					}
				}
				break;
		}

		trackButtonClick(`${getTrackingName()}:${buttonNames.continue}`);
	};

	//TODO: Whoever working on step2 please update this method
	const ValidateStep2Data = () => {
		if (
			nodes &&
			nodes.length > 0 &&
			!nodes.some((x) => !x.entityName.trim() || x.entityName === labels.enterEntityName)
		) {
			return true;
		}
		return false;
	};

	const ValidateStep3Data = () => {
		// At least one engagement should be associated to org chart.
		return nodes.some((x) => {
			return x.engagements.length > 0;
		});
	};

	const handlerOnSaveAsDraftClick = () => {
		const clickActionName = `${getTrackingName()}:${buttonNames.saveAsDraft}`;

		if (project.Id == '') {
			trackButtonClick(clickActionName);
			return;
		}

		let drafturl = `${env.getBaseURL(serviceURL)}Projects/${project.Id}`;
		if (isEditMode) {
			drafturl = `${env.getBaseURL(serviceURL)}Projects/${project.id}`;
		}
		let savedProject = null;

		switch (activeStepIndex) {
			// we have to update same data (nodes) in step 2 and 3
			// after save as draft navigate user to list page
			// Update redux state after draft api success
			case createProjectStepsIndex.selectClient:
				setIsSavingDraft(true);
				break;
			case createProjectStepsIndex.createOrgChart:
			case createProjectStepsIndex.connectToEYCanvas:
				let payload = {};
				if (isEditMode) {
					savedProject = {
						stepUpdated: activeStepIndex + 1,
						name: state.name !== '' ? state.name : project.name,
						status: projectStatusEnum.DRAFT,
						clients: !_.isEmpty(state.clients) ? [...state.clients] : [...project.clients],
						owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
						orgStructure: nodes.map((node) => {
							return {
								id: node.id.toString(),
								parentId: node.pid?.toString(),
								entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId,
								entityName: node.entityName,
								accessGroups: [],
								engagements: [...node.engagements],
								entityAdmins: node.admins,
								contacts: node.contacts,
								domains: node.domains
							};
						}),
						entitiesToBeEdited: nodes
							.filter((e) => e.isEdited)
							.map((o) => {
								return o.id.toString();
							})
					};
					payload = savedProject;
					setIsSaving(true);
					globalDispatch(draftProject(drafturl, payload))
						.then(() => {
							setIsSaving(false);
							globalDispatch(clearProject());
							globalDispatch(clearAllProjects());
							let url = '';
							if (isEditMode || (history.length <= 1 && !history.state)) {
								let path = `/projects`;
								history.push(path, null);
								url = `${window.location.origin}${path}`;
							} else {
								props.history.goBack();
								url = props.location.state.prevUrl;
							}
							trackButtonClick(clickActionName, url);
						})
						.catch((e) => {
							console.error(e);
							setIsSaving(false);
						});
				} else {
					savedProject = {
						stepUpdated: activeStepIndex + 1,
						...project,
						status: projectStatusEnum.DRAFT,
						clients: [...project.clients],
						owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
						orgStructure: nodes.map((node) => {
							return {
								id: node.id.toString(),
								parentId: node.pid?.toString(),
								entityName: node.entityName,
								entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId,
								accessGroups: [],
								engagements: [...node.engagements],
								entityAdmins: node.admins,
								contacts: node.contacts,
								domains: node.domains
							};
						}),
						entitiesToBeEdited: nodes
							.filter((e) => e.isEdited)
							.map((o) => {
								return o.id.toString();
							})
					};
					payload = savedProject;
					payload.users = [];
					setIsSaving(true);
					globalDispatch(draftProject(drafturl, payload))
						.then(() => {
							setIsSaving(false);
							globalDispatch(clearProject());
							globalDispatch(clearAllProjects());
							let url = '';
							if (isEditMode || (history.length <= 1 && !history.state)) {
								let path = `/projects`;
								history.push(path, null);
								url = `${window.location.origin}${path}`;
							} else {
								props.history.goBack();
								url = props.location.state.prevUrl;
							}
							trackButtonClick(clickActionName, url);
						})
						.catch((e) => {
							console.error(e);
							setIsSaving(false);
						});
				}
				break;
			case createProjectStepsIndex.viewSummary:
				let payloadDataStep5 = {};
				if (isRollForwardMode) {
					savedProject = {
						...project,
						stepUpdated: activeStepIndex + 1,
						status: projectStatusEnum.DRAFT,
						clients: [...project.clients],
						owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
						users: [...project.users],
						orgStructure: nodes.map((node) => {
							return {
								id: node.id.toString(),
								parentId: node.pid?.toString(),
								entityName: node.entityName,
								accessGroups: [...node.accessGroups],
								engagements: [...node.engagements],
								entityAdmins: node.admins,
								contacts: node.contacts,
								domains: node.domains
							};
						}),
						entitiesToBeEdited: nodes
							.filter((e) => e.isEdited)
							.map((o) => {
								return o.id.toString();
							})
					};

					payloadDataStep5 = savedProject;
				}
				// Todo - check if we can use above RF condition as no change in code
				else {
					savedProject = {
						...project,
						stepUpdated: activeStepIndex + 1,
						status: projectStatusEnum.DRAFT,
						clients: [...project.clients],
						owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
						users: [],
						orgStructure: nodes.map((node) => {
							return {
								id: node.id.toString(),
								parentId: node.pid?.toString(),
								entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId,
								entityName: node.entityName,
								accessGroups: [...node.accessGroups],
								engagements: [...node.engagements],
								entityAdmins: node.admins,
								contacts: node.contacts,
								domains: node.domains
							};
						}),
						entitiesToBeEdited: nodes
							.filter((e) => e.isEdited)
							.map((o) => {
								return o.id.toString();
							})
					};

					payloadDataStep5 = savedProject;
				}

				setIsSaving(true);
				globalDispatch(draftProject(drafturl, payloadDataStep5))
					.then(() => {
						setIsSaving(false);
						globalDispatch(setRollForwardMode(false));
						globalDispatch(clearProject());
						globalDispatch(clearAllProjects());
						globalDispatch(setOversightActiveTab(oversightTabs.activeProjects));
						let url = '';
						if (isEditMode || isRollForwardMode || (history.length <= 1 && !history.state)) {
							const path = `/projects`;
							history.push(path, null);
							url = `${window.location.origin}${path}`;
						} else {
							props.history.goBack();
							url = props.location.state.prevUrl;
						}
						trackButtonClick(clickActionName, url);
					})
					.catch((e) => {
						console.error(e);
						setIsSaving(false);
					});
				break;
		}
	};

	//Save button. End of story.
	const handlerOnFinishClick = () => {
		let savedProject = null;
		let payloadData = {};
		let drafturl = `${env.getBaseURL(serviceURL)}Projects/${project.id}`;

		if (isEditMode) {
			savedProject = {
				name: state.name !== '' ? state.name : project.name,
				stepUpdated: activeStepIndex + 1,
				status: projectStatusEnum.ACTIVE,
				clients: !_.isEmpty(state.clients) ? [...state.clients] : [...project.clients],
				owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
				orgStructure: nodes.map((node) => {
					return {
						id: node.id.toString(),
						parentId: node.pid?.toString(),
						entityName: node.entityName,
						entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId,
						accessGroups: [...node.accessGroups],
						engagements: [...node.engagements],
						entityAdmins: node.admins,
						contacts: node.contacts,
						domains: node.domains
					};
				}),
				entitiesToBeEdited: nodes
					.filter((e) => e.isEdited)
					.map((o) => {
						return o.id.toString();
					})
			};

			payloadData = savedProject;
		} else if (isRollForwardMode) {
			drafturl = `${env.getBaseURL(serviceURL)}Projects/${project.Id}`;
			savedProject = {
				name: state.name,
				stepUpdated: activeStepIndex + 1,
				status: projectStatusEnum.ACTIVE,
				clients: [...state.clients],
				owners: !_.isEmpty(state.owners) ? [...state.owners] : [...project.owners],
				users: [...project.users],
				orgStructure: nodes.map((node) => {
					return {
						id: node.id.toString(),
						parentId: node.pid?.toString(),
						entityName: node.entityName,
						accessGroups: [...node.accessGroups],
						engagements: [...node.engagements],
						entityAdmins: node.admins,
						domains: node.domains,
						contacts: node.contacts
					};
				}),
				entitiesToBeEdited: nodes
					.filter((e) => e.isEdited)
					.map((o) => {
						return o.id.toString();
					})
			};

			payloadData = savedProject;
		} else {
			drafturl = `${env.getBaseURL(serviceURL)}Projects/${project.Id}`;
			// Todo - Need to discuss/check why users property is not accepted in savedProject API.
			const {users, ...projectExcludeUser} = project;
			savedProject = {
				...projectExcludeUser,
				isSave: false,
				stepUpdated: activeStepIndex + 1,
				status: projectStatusEnum.ACTIVE,
				clients: [...projectExcludeUser.clients],
				owners: !_.isEmpty(state.owners) ? [...state.owners] : [...projectExcludeUser.owners],
				orgStructure: nodes.map((node) => {
					return {
						id: node.id.toString(),
						parentId: node.pid?.toString(),
						entityName: node.entityName,
						accessGroups: [...node.accessGroups],
						engagements: [...node.engagements],
						entityAdmins: node.admins,
						domains: node.domains,
						entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId
					};
				}),
				entitiesToBeEdited: nodes
					.filter((e) => e.isEdited)
					.map((o) => {
						return o.id.toString();
					})
			};
			payloadData = savedProject;
		}

		setIsSaving(true);
		globalDispatch(finishProject(drafturl, payloadData, isRollForwardMode))
			.then(() => {
				globalDispatch(clearProject());
				globalDispatch(setRollForwardMode(false));
				let urlEditMode = isEditModeData?.redirect;
				if (urlEditMode && urlEditMode.includes(routeToRedirectEditProject.dashbaord)) {
					globalDispatch(setEditMode(false, null, null, null));
				}
				globalDispatch(clearAllProjects());
				globalDispatch(setOversightActiveTab(oversightTabs.activeProjects));
				project?.id && globalDispatch(getProjectDetails(project.id));
				setIsSaving(false);
				let path = '';
				if (isEditMode || (history?.length <= 1 && history.state)) {
					history.push(urlEditMode, null);
					path = urlEditMode;
				} else {
					path = `/projects`;
					history.push(path, null);
				}
				trackButtonClick(`${getTrackingName()}:${buttonNames.finish}`, `${window.location.origin}${path}`);
			})
			.catch((e) => {
				console.error(e);
				setIsSaving(false);
			});
	};
	//Return to previous page.
	const handlerNavigateBack = () => {
		const clickActionName =
			`${getTrackingName()}:` +
			(activeStepIndex === createProjectStepsIndex.selectClient ? `${buttonNames.cancel}` : `${buttonNames.back}`);
		let url = '';

		if (activeStepIndex === 0) {
			globalDispatch(clearProject());
			if (isEditMode || (history?.length <= 1 && history.state)) {
				let urlEditMode = isEditModeData?.redirect;
				globalDispatch(setEditMode(false, null, null, null));
				history.push(urlEditMode, null);
				url = `${window.location.origin}${urlEditMode}`;
			} else {
				if (projectId || (history?.length <= 1 && !history.state)) {
					const path = `/projects`;
					history.push(path, null);
					url = `${window.location.origin}${path}`;
				} else {
					props.history.goBack();
					url = props.location.state.prevUrl;
				}
			}
		} else {
			setShowWarningForBack(true);
		}

		trackButtonClick(clickActionName, url);
	};

	const cancelLinkClickCallback = () => {
		let url = '';

		if (project.status === '' || project.status === projectStatusEnum.INITIAL) {
			let savedProject = {
				...project,
				status: projectStatusEnum.CANCELLED,
				owners: [...state.owners],
				users: [],
				orgStructure: nodes.map((node) => {
					return {
						id: node.id.toString(),
						parentId: node.pid?.toString(),
						entityName: node.entityName,
						accessGroups: [...node.accessGroups],
						engagements: [...node.engagements],
						entityAdmins: node.admins,
						domains: node.domains,
						entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId
					};
				})
			};
			let payload = {
				savedProject
			};

			let projectApiUrl = `${env.getBaseURL(serviceURL)}Projects/${project.Id}`;
			globalDispatch(updateProject(projectApiUrl, payload, isRollForwardMode));
		}

		if (isRollForwardMode) {
			globalDispatch(setRollForwardMode(false));
			if (oversightActiveTab === oversightTabs.completedProjects) {
				globalDispatch(setOversightActiveTab(oversightTabs.completedProjects));
			} else {
				globalDispatch(setOversightActiveTab(oversightTabs.activeProjects));
			}
		}
		globalDispatch(clearProject());
		let urlEditMode = isEditModeData?.redirect;
		globalDispatch(setEditMode(false, null, null, null));
		if (isEditMode || (history?.length <= 1 && history.state)) {
			history.push(urlEditMode, null);
			url = `${window.location.origin}${urlEditMode}`;
		} else {
			if (projectId || (history?.length <= 1 && !history.state)) {
				const path = `/projects`;
				history.push(path, null);
				url = `${window.location.origin}${path}`;
			} else {
				props.history.goBack();
				url = props.location.state.prevUrl;
			}
		}

		trackButtonClick(`${getTrackingName()}:${buttonNames.cancel}`, url);
	};

	// If user clicks on ok for navigating to previous step
	const navigateTopreviousStep = () => {
		setShowWarningForBack(false);
		setIsNavigatedFromPreviousStep(true);
		if (isEditModeData.nodes !== null) {
			setIsSaving(true);
			globalDispatch(getProjectToEdit(projectId, true)).then(() => {
				setIsSaving(false);
			});
		}
		if (navigateToSpecificStep === null) {
			setActiveStepIndex(activeStepIndex - 1);
			if (projectId) {
				history.push(`/projects/project?projectId=${projectId}&step=${activeStepIndex}`, null);
			}
		} else {
			setActiveStepIndex(navigateToSpecificStep);
			if (projectId) {
				history.push(`/projects/project?projectId=${projectId}&step=${navigateToSpecificStep + 1}`, null);
			}
			setNavigateToSpecificStep(null);
		}
		setContinueToNextStep(false);

		const clickActionName = `${getTrackingName()}:${clickActionNames.returnToPreviousStep}:${buttonNames.continue}`;
		trackButtonClick(clickActionName, '', false);
	};

	const trackButtonClick = (clickActionName, url = '', isPageView = true) => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				clickActionName,
				controlTypes.button,
				isPageView ? locationInPages.footerBottom : locationInPages.modalPopup,
				url
			)
		);
	};

	const getTrackingName = () => {
		switch (activeStepIndex) {
			case createProjectStepsIndex.createOrgChart:
				return clickActionNames.step2CreateOrgChart;
			case createProjectStepsIndex.connectToEYCanvas:
				return clickActionNames.step3ConnectToEyCanvas;
			case createProjectStepsIndex.viewSummary:
				return clickActionNames.step4ViewSummary;
			case createProjectStepsIndex.selectClient:
			default:
				return clickActionNames.step1SelectClient;
		}
	};

	const Step1 = (
		<CreateProjectStep1
			key={'selectClient'}
			nodes={nodes}
			setNodes={setNodes}
			continueToNextStep={continueToNextStep && activeStepIndex === 0}
			setContinueToNextStep={setContinueToNextStep}
			isSavingDraft={isSavingDraft}
			setIsSavingDraft={setIsSavingDraft}
			setIsSaving={setIsSaving}
			activeStepIndex={activeStepIndex}
			setActiveStepIndex={setActiveStepIndex}
			isNavigatedFromPreviousStep={isNavigatedFromPreviousStep}
			setIsNavigatedFromPreviousStep={setIsNavigatedFromPreviousStep}
			setClientsLoading={setClientsLoading}
			clientsLoading={clientsLoading}
		/>
	);

	const Step2 = (
		<CreateProjectStep2
			key={'createOrgChart'}
			nodes={nodes}
			setNodes={setNodes}
			continueToNextStep={continueToNextStep && activeStepIndex === 1}
			setContinueToNextStep={setContinueToNextStep}
			saveAsDraft={saveAsDraft}
			setActiveStepIndex={setActiveStepIndex}
		/>
	);

	const Step3 = (
		<CreateProjectStep3
			key={'connectToEYCanvas'}
			nodes={nodes}
			setNodes={setNodes}
			continueToNextStep={continueToNextStep && activeStepIndex === 2}
			setContinueToNextStep={setContinueToNextStep}
			setActiveStepIndex={setActiveStepIndex}
		/>
	);

	const Step4 = (
		<CreateProjectStep4
			key={'viewSummary'}
			nodes={nodes}
			setNodes={setNodes}
			setNavigateToSpecificStep={setNavigateToSpecificStep}
			setShowWarningForBack={setShowWarningForBack}
		/>
	);

	const propsSteps = {
		steps: wizardSteps,
		currentStepIndex: activeStepIndex,
		stepContent: [Step1, Step2, Step3, Step4],
		buttons: buttons.filter((b) => b.isVisible === true),
		indicatorClasses: 'padding-top-step',
		contentClasses: 'progess-indicator-content template-padding-sides',
		buttonsClasses: 'template-padding-sides'
	};

	const hideModal = () => {
		setShowWarningForBack(false);

		const clickActionName = `${getTrackingName()}:${clickActionNames.returnToPreviousStep}:${buttonNames.cancel}`;
		trackButtonClick(clickActionName, '', false);
	};

	return (
		<ProjectContext.Provider value={{state: state, dispatch: dispatch}}>
			<TemplateFullPage includeScroll={false}>
				<StyledWizard>
					{showWarningForBack && (
						<Modal
							show={showWarningForBack}
							showButtons
							modalsize={'small'}
							isOkButtonDisabled={false}
							hideCancelButton={false}
							title={labels.returnToPreviousStep}
							confirmBtnTitle={labels.continue}
							closeBtnTitle={labels.cancelLabel}
							onOkClick={() => navigateTopreviousStep()}
							onHide={() => hideModal()}
							closeTitle={labels.closeLabel}
						>
							{Utility.createRichTextElement(labels.backButtonWarning)}
						</Modal>
					)}
					<ProgressIndicator {...propsSteps} />
				</StyledWizard>
				<StyledLoader>
					<Loader className="show-at-top" show={isSaving || (clientsLoading && activeStepIndex !== 0)} />
				</StyledLoader>
			</TemplateFullPage>
		</ProjectContext.Provider>
	);
};

export default CreateProjectClassic;
